import { Grid, withStyles } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { CreateApartment } from '../../../actions/types'
import FormContainer from '../../../components/Container/FormContainer'
import { MuiClasses } from '../../../types'

const styles = () => ({
  button: {
    borderColor: '#94004A',
    borderWidth: '2px',
    color: '#94004A',
    '&:hover': {
      borderColor: '#94004A',
      borderWidth: '2px'
    }
  }
})

interface AdminApartmentsToolbarProps {
  classes: MuiClasses
  createApartment: CreateApartment
  t: i18n.TFunction
}

const AdminApartmentsToolbar: FC<AdminApartmentsToolbarProps> = ({
  t,
  createApartment,
  classes
}) => {
  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item sm={3}>
        <FormContainer
          form='CreateApartmentForm'
          submitButton
          submitAction={createApartment}
          customClasses={classes.button}
          buttonLabel={t('profile.createApartment')}
        />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(AdminApartmentsToolbar)
